<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data: function() {
        return {};
    },
    created() {
        // this.$router.push({
        //     name: "dashboard"
        // });
    },
    methods: {
        write: function() {}
    }
};
</script>

